/**
 * The searches somebody ran lately, on this device.
 *
 * Per device and in localStorage for the same reason recent locations are: it
 * is a shortcut rather than data, and losing it costs a retype. *Saved*
 * searches are the other kind -- named on purpose, kept on the server, and
 * there on every device -- and live in the inventory.
 *
 * What is stored is the search screen's own query string, so restoring one is a
 * navigation and nothing needs to know what the parts mean.
 */

const KEY = "iltocat.recent.searches";
const KEEP = 8;

export function readRecentSearches(): string[] {
  try {
    const parsed: unknown = JSON.parse(window.localStorage.getItem(KEY) ?? "[]");
    return Array.isArray(parsed)
      ? parsed.filter((entry): entry is string => typeof entry === "string").slice(0, KEEP)
      : [];
  } catch {
    return [];
  }
}

/** Newest first, without repeats. Returns the new list so a screen can show it without re-reading. */
export function rememberSearch(query: string): string[] {
  const clean = query.trim();
  const current = readRecentSearches();
  if (!clean) return current;

  const next = [clean, ...current.filter((entry) => entry !== clean)].slice(0, KEEP);
  try {
    window.localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // Storage being unavailable costs a shortcut, not a search.
  }
  return next;
}

export function forgetSearches(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // Nothing to forget, then.
  }
}
